import { Box, Fade, Grid, Slide, Typography } from '@mui/material'

import lfSensorImage from '../../../images/meet-sensor-nbiot_leak.svg'
import useStyles from '../index.styles'

const MeetSensorLeakFreeze = ({ fadeIn }: { fadeIn: boolean }) => {
  const classes = useStyles

  return (
    <>
      <Box sx={classes.lfImageContainer}>
        <img src={lfSensorImage} alt="" />
      </Box>

      <Slide direction="left" in={true} mountOnEnter timeout={1000}>
        <Grid container={true} sx={classes.lfTitleContainer}>
          <Typography variant="h4" sx={classes.lfHeading}>
            Meet your
          </Typography>

          <Typography variant="h3" sx={classes.lfTitle}>
            Leak Freeze Sensor
          </Typography>
        </Grid>
      </Slide>

      <Fade in={fadeIn} timeout={1000}>
        <Grid container={true} sx={classes.lfSubtitleContainer}>
          <Typography variant="h4" sx={classes.lfHeading}>
            Detect Leaks
          </Typography>

          <Typography variant="h4" sx={classes.lfHeading}>
            Prevent Frozen Pipes
          </Typography>

          <Typography variant="h4" sx={classes.lfHeading}>
            Stay Protected
          </Typography>
        </Grid>
      </Fade>
    </>
  )
}

export default MeetSensorLeakFreeze
